import { render } from "./MyTicketActivity.vue?vue&type=template&id=71d22ceb&scoped=true"
import script from "./MyTicketActivity.vue?vue&type=script&lang=js"
export * from "./MyTicketActivity.vue?vue&type=script&lang=js"

import "./MyTicketActivity.vue?vue&type=style&index=0&id=71d22ceb&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d22ceb"]])

export default __exports__